import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AnnotatorConfig } from '../../annotations/shared/annotator-config';
import { Type } from '../../annotations/shared/Tools/annotator-tool';
import { ApiService } from '../../rl-common/shared/shared/interfaces/api-service';
import { StudentSubmission } from '../shared/student-submission';
import { Submission } from '../shared/submission';

@Injectable({
  providedIn: 'root'
})
export class SubmissionService implements ApiService<Submission> {
  
  constructor(private http : HttpClient) { }

  getAll = (asgmtId : string) : Observable<Submission[]> => this.http.get<Submission[]>(`../rl/assignments/${asgmtId}/submissions`);

  get = (id?: string) : Observable<Submission> => this.http.get<Submission>(`../rl/assignments/0/submissions/${id}`);
  
  create = (sub : Submission) : Observable<Submission> => this.http.put<Submission>(`../rl/assignments/${sub.assignmentId}/submissions/${sub.id}`, sub);

  submit = (sub : Submission) : Observable<Submission> => this.http.put<Submission>(`../rl/assignments/${sub.assignmentId}/submissions/${sub.id}/submit`, {});
  
  save = (sub : Submission) : Observable<Submission> => this.http.put<Submission>(`../rl/assignments/${sub.assignmentId}/submissions/${sub.id}`, sub);

  delete = (sub: Submission) : Observable<void> => this.http.delete<void>(`../rl/assignments/${sub.assignmentId}/submissions/${sub.id}`);

  getStudentsNotGraded = (asgmtId : string) : Observable<StudentSubmission[]> => this.http.get<StudentSubmission[]>(`../rl/assignments/${asgmtId}/submissions/students/notGraded`);

  loadUserSubmissionForAsgmt = (asgmtId : string) : Observable<Submission> => this.http.post<Submission>(`../rl/assignments/${asgmtId}/mySubmission`, {});

  getAnnotationsConfig(): AnnotatorConfig {
    let annsConf : AnnotatorConfig = new AnnotatorConfig();
    annsConf.commentsConfig.visibility = "public";
    annsConf.commentsConfig.privateIndication = false;
    annsConf.canCloseCommentsPanel = false;
    annsConf.toolsDisabled.push(Type.highlight, 'SHAPE_NO_CMT');
    return annsConf;
  }
  
}
